import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { ApiService } from "./api.service";
import { HttpClient } from "@angular/common/http";

export class Group {
  id: number;
  id_subject?: number;
  id_group?: number;
  id_subgroup?: number;
  icon?: string;
  img?: string;
  level: string;
  subject: string;
  grade: string;
  group: string;
  isLive?: boolean;
}

@Injectable({
  providedIn: "root",
})
export class GroupsService {
  groups = new BehaviorSubject(null);
  _groups: Array<Group> = [];
  _groups_mixed: Array<Group> = [];

  constructor(private http: HttpClient) {}

  setGroups(groups: Array<Group>, mixed?: boolean): void {
    if (mixed) {
      this._groups_mixed = groups;
    } else {
      this._groups = groups;
    }
    this.groups.next(true);
  }

  getGroups(mixed?: boolean): Array<Group> {
    return mixed ? this._groups_mixed : this._groups;
  }

  deleteGroups(): void {
    this._groups = [];
    this._groups_mixed = [];
    this.groups.next(true);
  }

  duplicateGroup(groupId: number | string): Observable<{ newGroupId: number }> {
    return this.http.post<{ newGroupId: number }>(
      `group/duplicate/${groupId}`,
      {}
    );
  }
}
